<template>
  <div class="html-display" v-html="content"></div>
</template>

<script>
export default {
  name: "HTMLDisplay",
  props: {
    content: {
      required: true,
    },
  },
};
</script>

<style lang="scss">
#app {
  .html-display {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: flex-start;
    padding: 0 1em;

    .html-block {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      align-items: flex-start;
      &.with-border {
        border: 1px solid;
        padding: 0 1em;
        margin-bottom: 1em;
      }
      &.centered {
        align-items: center;
      }
      &.html-block-list {
        flex-wrap: nowrap;
        flex-direction: row;
        align-items: center;
        margin-bottom: 1.5em;
        ul {
          width: 50%;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          margin: 0.5em auto;
          padding: 0 1em;
          li {
            width: 50%;
          }
        }
      }
    }

    .headline {
      font-family: "Forza";
      text-transform: uppercase;
      font-style: italic;
      font-size: 1.4em;
      line-height: 1.4em;
      text-align: left;
      &.with-border {
        font-family: "ForzaBold";
        border: 1px solid;
        padding: 0 1em;
      }
    }

    .brand-container {
      max-height: 6em;
      display: flex;
      margin-top: 2em;
      &.centered {
        justify-content: center;
        width: 100%;
      }
      .brand-logo {
        width: auto;
        max-height: 100%;
        max-width: 100%;
      }
      .brand-row {
        display: flex;
        align-items: flex-end;
        flex-direction: row;
        margin-bottom: 1em;
        .headline {
          padding-left: 0.5em;
        }
      }
    }

    .divider {
      height: 1px;
      background-color: black;
      width: 80%;
      margin: 0 auto 0.8em;
    }
    ul {
      width: 100%;
      list-style: none;
      font-size: 1em;
      text-overflow: ellipsis;
      color: #26262c;
      margin: 0 auto 1em;

      li:before {
        content: "•";
        padding-right: 0.2em;
      }

      li.bold {
        font-weight: 700;
      }
    }
  }
}
</style>